import type { RichToolCall } from "@/lib/ag-ui-types"
import { SearchResultsCard } from "./search-results-card"
import { RecordDetailCard } from "./record-detail-card"
import { ActionCard } from "./action-card"
import { NavigationCard } from "./navigation-card"
import { AnalyticsCard } from "./analytics-card"

type CardComponent = React.ComponentType<{ toolCall: RichToolCall }>

const SEARCH_TOOLS = new Set(["global_search", "search_companies", "search_contacts", "search_deals", "search_tasks", "search_invoices", "search_quotes", "search_products", "search_tickets", "search_activities", "web_search"])
const GET_TOOLS = new Set(["get_company", "get_contact", "get_deal", "get_task", "get_invoice", "get_quote", "get_product", "get_ticket"])
const ACTION_TOOLS = new Set(["create_company", "create_contact", "create_deal", "create_task", "create_note", "update_company", "update_contact", "update_deal", "change_deal_phase", "mark_deal_won", "mark_deal_lost", "complete_task", "log_activity", "draft_email"])
const NAV_TOOLS = new Set(["navigate_to"])
const ANALYTICS_TOOLS = new Set(["get_dashboard_stats", "get_revenue_trend", "analyze_sales_performance", "compare_periods", "get_deal_forecast", "get_pipeline_summary", "get_upcoming_activities", "get_my_tasks", "summarize_entity_history"])

export function getToolCardComponent(toolName: string): CardComponent {
  if (SEARCH_TOOLS.has(toolName)) return SearchResultsCard
  if (GET_TOOLS.has(toolName)) return RecordDetailCard
  if (ACTION_TOOLS.has(toolName)) return ActionCard
  if (NAV_TOOLS.has(toolName)) return NavigationCard
  if (ANALYTICS_TOOLS.has(toolName)) return AnalyticsCard
  return ActionCard // Fallback
}

export function RichToolCardRenderer({ toolCall }: { toolCall: RichToolCall }) {
  const Component = getToolCardComponent(toolCall.name)
  return <Component toolCall={toolCall} />
}
